import React from "react";
import PropTypes from "prop-types";

const FemaleGenderIcon = ({ className }) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M5.5 7.64844C8.2748 7.64844 10.4998 9.83642 10.5 12.5127C10.5 12.6744 10.3621 12.8231 10.1738 12.8232H0.831055C0.636256 12.8232 0.5 12.6726 0.5 12.5127C0.500212 9.83642 2.7252 7.64844 5.5 7.64844ZM2.76074 2.42969C3.2008 1.00654 4.7511 0.180533 6.23242 0.616211H6.2334C7.13207 0.87921 7.82861 1.56353 8.09473 2.42871V2.42969L9.02246 5.4248C9.07073 5.58066 8.98435 5.75343 8.80762 5.80371H8.80664C8.76366 5.81604 8.73269 5.82028 8.70605 5.82031H2.14941C2.04032 5.82018 1.94187 5.76934 1.88281 5.69141C1.82449 5.61436 1.80636 5.5158 1.83496 5.41992L1.83398 5.41895L2.76074 2.42969Z"
      stroke="currentColor"
    />
  </svg>
);

FemaleGenderIcon.propTypes = {
  className: PropTypes.string,
};

FemaleGenderIcon.defaultProps = {
  className: undefined,
};

export default FemaleGenderIcon;
